import { useState, useLayoutEffect } from 'react';

// Utility function to check if the device is mobile
// Make sure to define `checkMobile` function or import it if it's defined elsewhere
const checkMobile = () => {
  // Example implementation, might need to adjust based on your criteria
  return window.innerWidth < 431;
};

// Custom hook to handle mobile status
export const useMobileStatus = () => {
  const [isMobile, setIsMobile] = useState(checkMobile());

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(checkMobile());
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty array ensures this effect runs only once on mount

  return isMobile;
};



// WEBPACK FOOTER //
// ./src/new/Utils/useMobileStatus.jsx